import React from 'react';
import { PropsWithChildren } from '../../../types/props-with-children';

export const AriaLiveWrapper: React.FC<PropsWithChildren> = (props: PropsWithChildren) => (
    <span aria-live="polite">{props.children}</span>
);
